import React from "react";

import { useMutation, useQuery } from "@apollo/client";
import { styled, Typography } from "@mui/material";

import { graphql } from "@/gql";
import { CreateStripeCustomerPortalSessionInput } from "@/gql/graphql";

import CurrentSubscriptionCard from "../components/CurrentSubscriptionCard";

const Root = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 4),
}));

const subscriptionPageQuery = graphql(`
  query SubscriptionPage {
    ...CurrentSubscriptionCard
  }
`);

const createStripeCustomerPortalSessionMutation = graphql(`
  mutation CreateStripeCustomerPortalSession(
    $input: CreateStripeCustomerPortalSessionInput!
  ) {
    createStripeCustomerPortalSession(input: $input) {
      customerPortalUrl
    }
  }
`);

const SubscriptionPage: React.FC = () => {
  const { data, loading } = useQuery(subscriptionPageQuery);

  const [createStripeCustomerPortalSession] = useMutation(
    createStripeCustomerPortalSessionMutation
  );

  const handleManageSubscription = async () => {
    const input: CreateStripeCustomerPortalSessionInput = {
      returnUrl: `${import.meta.env.VITE_APP_URL}/subscription`,
    };

    const result = await createStripeCustomerPortalSession({
      variables: { input },
    });
    const url =
      result.data?.createStripeCustomerPortalSession?.customerPortalUrl;

    if (url) window.location.replace(url);
  };

  return (
    <Root>
      <Typography variant="body1" fontWeight="bold" paddingY={2}>
        My Subscription
      </Typography>
      <CurrentSubscriptionCard
        data={data}
        loading={loading}
        onManageSubscription={handleManageSubscription}
      />
    </Root>
  );
};

export default SubscriptionPage;
